import { getBootstrapData } from "@swa-ui/bootstrap";
import { swaDate } from "@swa-ui/date";
import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

import { FLIGHT_CAR, FLIGHT_HOTEL, FLIGHT_HOTEL_CAR } from "../defines/packageType";
import { getDepartureDateSchema, getReturnDateSchema } from "./getDateSchema";

export const vacationsBookingFormSchema = ({ vacationsFirstDepartureDate } = {}) => {
  const stationIds = getBootstrapData("air/stations-data").map((station) => station.id);

  return yup
    .object()
    .shape({
      packageType: yup
        .string()
        .trim()
        .required()
        .oneOf([FLIGHT_HOTEL, FLIGHT_CAR, FLIGHT_HOTEL_CAR])
        .default(FLIGHT_HOTEL),
      destinationAirportCode: yup
        .string()
        .trim()
        .required()
        .label(i18n("schema__DESTINATION").toLowerCase()),
      originationAirportCode: yup
        .string()
        .trim()
        .uppercase()
        .required()
        .oneOf(stationIds)
        .label(i18n("schema__DEPARTURE_AIRPORT").toLowerCase()),
      departureDate: getDepartureDateSchema(vacationsFirstDepartureDate),
      returnDate: getReturnDateSchema(vacationsFirstDepartureDate),
      promoCode: yup.string().alphaNumeric().trim(),
      travelers: yup.array().default([{ adults: 2, children: 0, childrenAge: [], lapChildren: 0 }]),
    })
    .noUnknown();
};
